import React from "react";
import "../styles/components/domain-setup.css";

const DnsInstructions = () => {
  return (
    <div className="container">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>TTL</th>
            <th>Type</th>
            <th>Record</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>sst</td>
            <td>300</td>
            <td>A</td>
            <td>185.101.32.198</td>
          </tr>
        </tbody>
      </table>

      <p className="text">
        For å legge til en DNS-post, logg inn på DNS-administrasjonspanelet hos
        din domeneleverandør og legg til en A-post med detaljene som er oppgitt
        i tabellen ovenfor. Navnet er vanligvis et subdomene, TTL kan være
        standard eller settes til 300, og typen må være &quot;A&quot; som peker
        til den oppgitte IP-adressen.{" "}
        <b>Se egne instruksjoner for din DNS-leverandør under:</b>
      </p>

      <ul>
        <li>
          <a
            href="https://domene.shop/faq?id=15"
            target="_blank"
            rel="noopener noreferrer"
          >
            Domene.shop
          </a>
        </li>
        <li>
          <a
            href="https://developers.cloudflare.com/dns/manage-dns-records/how-to/create-dns-records/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Cloudflare
          </a>
        </li>
        <li>
          <a
            href="https://no.godaddy.com/help/administrer-dns-oppforinger-680"
            target="_blank"
            rel="noopener noreferrer"
          >
            GoDaddy
          </a>
        </li>
        <li>
          <a
            href="https://www.domene.no/support/domenenavn/endre-dns.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Domene.no
          </a>
        </li>
        <li>
          <a
            href="https://www.dedia.no/kunde/knowledgebase/30/Se-og-endre-DNS-oppforinger-for-domene-A-CNAME-MX-TXT-SRV-etc..html?language=english"
            target="_blank"
            rel="noopener noreferrer"
          >
            Dedia
          </a>
        </li>
      </ul>
    </div>
  );
};

export default DnsInstructions;
